<template>
  <div :class="componentClasses">
    <label>
      <slot />
    </label>
  </div>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  icon: {
    type: String,
    default: 'fas fa-chevron-down',
  },
  size: {
    type: String,
    default: '3_5',
  },
});

const componentClasses = computed(() => [
  'stk-label',
  props.size && `stk-size-${props.size}`,
]);
</script>


<style>
.stk-label {
  color: var(--stk-text-weak);
  font-weight: 500;
  line-height: 1.25;

  label {
    font-weight: 500;
  }
}
</style>
